module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"title":"第三方登录","type1":"微博登录","type2":"微信登录","type3":"推特登录"},"TW":{"title":"協力廠商登入","type1":"微博登入","type2":"微信登入","type3":"推特登入"},"en":{"title":"Third party login","type1":"Login via Weibo","type2":"Login via Wechat","type3":"Login in via Twitter "}}')
  delete Component.options._Ctor
}
